// or your router
import { Box } from "@mui/material";
import { AnchorHTMLAttributes, ClassAttributes, useMemo } from "react";
import { ExtraProps } from "react-markdown";

import { YouTubeHelper } from "@/common/helpers/youTube";

import { MarkdownElCommonProps } from "../MarkdownRenderer";
import { MarkdownIframeElOfYouTubeVideo } from "./MarkdownIframeElOfYouTubeVideo";

type Props = ClassAttributes<HTMLAnchorElement> &
  AnchorHTMLAttributes<HTMLAnchorElement> &
  ExtraProps &
  MarkdownElCommonProps & {
    isEmbedYouTubeVideo?: boolean;
  };

/** <a href="" /> element. */
export function MarkdownAnchorEl({
  isEmbedYouTubeVideo,
  isUseDefaultMargins,
  sx,
  node,
  href,
  children,
  ...otherProps
}: Props) {
  const youTubeUrlInfo = useMemo(() => YouTubeHelper.parseUrl(href), [href]);

  if (isEmbedYouTubeVideo && youTubeUrlInfo?.videoId) {
    return (
      <MarkdownIframeElOfYouTubeVideo
        urlInfo={youTubeUrlInfo}
        isUseDefaultMargins={isUseDefaultMargins}
        sx={sx}
      />
    );
  }

  return (
    <Box
      sx={sx}
      component='a'
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      {...otherProps}
    >
      {children}
    </Box>
  );
}
